// gatsby-browser.js
import React from 'react';
import { AudioPlayerProvider } from './src/components/AudioPlayer';
import LanguageProvider from './src/components/LanguageProvider';
import { AuthProvider } from './src/components/AuthProvider';
import Layout from './src/components/Layout';
import './src/styles/global.css';

// Fraunces — sistema de diseño S4/S5/S6, ver .claude/skills/design-system.md.
// Playfair Display se retiró en S6 (reemplazada 1:1 por Fraunces en todo el sitio).
if (typeof document !== 'undefined') {
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect1);

  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);

  const frauncesLink = document.createElement('link');
  frauncesLink.rel = 'stylesheet';
  frauncesLink.href = 'https://fonts.googleapis.com/css2?family=Fraunces:opsz,SOFT,WONK,wght@9..144,0..100,0..1,300..700&display=swap';
  document.head.appendChild(frauncesLink);
}

// Wraps the entire app with the Audio Context
export const wrapRootElement = ({ element }) => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AudioPlayerProvider>{element}</AudioPlayerProvider>
      </AuthProvider>
    </LanguageProvider>
  );
};

// Wraps every page with the Layout component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};